import React from 'react';

import { Player } from '@lottiefiles/react-lottie-player';
import LoadingAnimation from '../animation/loading.json';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '-100px',
    maxWidth: '400px',
    maxHeight: '400px',
  },
}));

/**
 * Loading component
 */
export const Loading = () => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Player autoplay={true} loop={true} src={LoadingAnimation} />
    </div>
  );
};
